export default "__VITE_ASSET__ClptrK1o__"